module.exports = __webpack_public_path__ + "img/background_c4-1-2.4f7d22b9.jpg";